<template>
    <ul class="multiselect">
        <li v-for="option in options">
            <button
                type="button"
                :class="getOptionClasses(option)"
                @click="toggleOption(option)">
                {{ getOptionLabel(option) }}
            </button>
        </li>
    </ul>
</template>

<script>
    // TODO: we shouldn't accept an options array, we should use slots. The
    // current approach makes things hard to use scoped styles.

    export default {
        name: 'multiselect',

        props: {
            options: {
                /**
                 * Options can be strings or objects.
                 *
                 * If an object, the option must contain a `value` property, and
                 * can optionally contain a `label` property.
                 */
                type: Array,
                required: true,
            },
            value: {
                /**
                 * Must be a string array, with elements matching the `value`
                 * properties from the `options` array.
                 */
                type: Array,
                required: true,
            },
        },

        methods: {
            getOptionValue(option) {
                if (typeof option === 'string') {
                    return option;
                } else {
                    return option.value;
                }
            },

            getOptionLabel(option) {
                if (typeof option === 'string') {
                    return option;
                } else {
                    return option.label || option.value;
                }
            },

            getOptionClasses(option) {
                return {
                    selected: this.isOptionEnabled(option),
                };
            },

            isOptionEnabled(option) {
                const optionValue = this.getOptionValue(option);
                return !!this.value.find(o => o === optionValue);
            },

            toggleOption(option) {
                let newValue;

                const optionValue = this.getOptionValue(option);
                const enabled = this.isOptionEnabled(option);
                if (enabled) {
                    newValue = this.value.filter(o => o !== optionValue);
                } else {
                    newValue = this.value.concat([optionValue]);
                }

                this.$emit('input', newValue);
            },
        },
    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        margin: 10px -15px -5px 0;
        padding: 0;
    }

    li {
        margin: 0 15px 15px 0;
        display: inline-block;
    }

    button {
        background-color: #0f0f0f;
        border: 1px solid #363636;
        padding: 1px 15px 3px;
        &:hover {
            border-color: #666;
        }
        &.selected {
            // Style 1
            //color: #33ccff;

            // Style 2
            //color: #0f0f0f;
            //background-color: #b0b0b0;
            //border-color: #666;

            // Style 3
            color: #f0f0f0;
            background-color: #363636;
            border-color: #666;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?88ca8698